/**
 * Suppresses specific mapping errors in the console output, particularly those
 * related to AEM components not being mapped for a given resourceType.
 *
 * This function overrides the default `console.error` behavior to filter out
 * error messages containing "Component not mapped for resourceType", preventing
 * them from being logged to the console. All other error messages are passed
 * through to the original `console.error`.
 *
 * @remarks
 * Call this function once during application initialization to activate the suppression.
 *
 * @example
 * suppressMappingErrors();
 */
const suppressMappingErrors = (): void => {
  // Save the original console.error
  const originalConsoleError = console.error

  console.error = (...args: unknown[]): void => {
    const message = args[0]
    // Check if it's the AEM component not mapped for resourceType warning
    if (
      typeof message === "string" &&
      message.includes("Component not mapped for resourcetype:")
    ) {
      return
    }

    // Pass through all other errors
    originalConsoleError(...args)
  }
}

export default suppressMappingErrors
